/**
 * Tracking related constants
 */

/**
 * All WEMF tracking types
 */
const WemfTypes = {
    ARTICLE: 'article',
    SLIDESHOW: 'gallery',
    TICKER: 'newsticker',
    VIDEO: 'video',
    VIDEO_SLIDER: 'video_slider'
};

/**
 * All GTM event names
 */
const GtmEvents = {
    PAGEVIEW: 'pageview',
    LOGIN_OVERLAY_DISPLAY: 'loginoverlay_display',
    LOGIN_OVERLAY_CLOSE: 'loginoverlay_close',
    LOGIN_OVERLAY_REGISTER: 'loginoverlay_register',
    LOGIN_OVERLAY_LOGIN: 'loginoverlay_login',
    LOGIN_OVERLAY_INFORMATION: 'loginoverlay_information',
    FEATURE_OVERLAY_DISPLAY: 'featureoverlay_display',
    FEATURE_OVERLAY_CLOSE: 'featureoverlay_close',
    FEATURE_OVERLAY_REGISTER: 'featureoverlay_register',
    FEATURE_OVERLAY_LOGIN: 'featureoverlay_login',
    FEATURE_OVERLAY_INFORMATION: 'featureoverlay_information',
    VIDEO_AD_START: 'video_ad_start',
    VIDEO_AD_COMPLETE: 'video_ad_complete',
    VIDEO_PLAY: 'video_play',
    VIDEO_RESUME: 'video_resume',
    VIDEO_PROGRESS: 'video_progress',
    VIDEO_SEEK: 'video_seek',
    VIDEO_COMPLETE: 'video_complete',
    VIDEO_SLIDER: 'video_slider',
    GALLERY_SWIPE: 'gallery_swipe',
    GALLERY_FULLSCREEN: 'gallery_fullscreen',
    LOGIN_ATTEMPT: 'login_attempt',
    INTERACTION: 'interaction',
    INTERACTION_RATING: 'interaction_rating',
    NAVIGATION: 'navigation',
    PROFILE_EDIT_CLICK: 'profile_edit_click',
    SHARE_WHATSAPP: 'whatsapp',
    SHARE_FACEBOOK: 'facebook',
    SHARE_MAIL: 'email',
    SHARE_LINK: 'copyLink',
    WIDGET_MOST_COMMENTED: 'widget_mostcommented',
    WIDGET_MOST_POPULAR: 'widget_mostpopular',
    WIDGET_RECENTLY_COMMENTED: 'widget_activitystream'
};

/**
 * All GTM page types for pageview tracking
 */
const GtmPageTypes = {
    ARTICLE: 'article_view',
    CHANNEL: 'channel_view',
    COCKPIT: 'cockpit_view',
    PROFILE: 'profile_view',
    FRONT: 'front_view',
    NEWSTICKER: 'newsticker_view',
    OTHER: 'other_view',
    SLIDESHOW: 'slideshow_view',
    VIDEO: 'video_view'
};

/**
 * All Beagle event names
 */
const BeagleEvents = {
    VIDEO_PERCENTAGE_WATCHED: 'videoPercentageWatched',
    OPEN_CATEGORY: 'openCategory',
    STORY_BOOKMARK: 'storyBookmark',
    VIDEO_BOOKMARK: 'videoBookmark',
    STORY_VOTE: 'storyVote',
    VIDEO_VOTE: 'videoVote',
    STORY_SHARE: 'storyShare',
    VIDEO_SHARE: 'videoShare',
    STORY_COPY_LINK: 'storyCopyLink',
    VIDEO_COPY_LINK: 'videoCopyLink',
    STORY_COMMENT: 'storyComment',
    VIDEO_COMMENT: 'videoComment',
    OPEN_STORY: 'openStory',
    OPEN_VIDEO: 'openVideo',
    STORY_COMMENT_VOTE: 'storyCommentVote',
    VIDEO_COMMENT_VOTE: 'videoCommentVote'
};

/**
 * Possible sources for interaction events
 */
const InteractionSources = {
    QUICKACTION_TEASER: 'quickaction_teaser',
    QUICKACTION_ARTICLE: 'quickaction_article',
    BUBBLE_TEASER: 'bubble_teaser',
    BUBBLE_ARTICLE: 'bubble_article',
    SHARE_OVERLAY: 'share_overlay'
};

export {WemfTypes, GtmEvents, GtmPageTypes, BeagleEvents, InteractionSources};
